<script>
  import Editor from '../../../utils/tui-editor/TuiEditor.svelte'

  export let initialValue = '';
</script>

<Editor on:change {initialValue} on:upload />
